import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-event-message',
  templateUrl: './event-message.component.html',
  styleUrls: ['./event-message.component.scss']
})
export class EventMessageComponent implements OnInit {
  modalRef: BsModalRef;
  isCollapsed = true;
  inboxTab: boolean = true;
  sentTab: boolean;
  spamTab: boolean;
  deleteTab: boolean;
  constructor(private modalService: BsModalService) { }

  ngOnInit(): void {
  }


  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
  }
  onMenuTab(number) {
    this.inboxTab = false;
    this.sentTab = false;
    this.spamTab = false;
    this.deleteTab = false;
    if (number == '1') {
      this.inboxTab = true;
    }
    else if (number == '2') {
      this.sentTab = true;
    }
    else if (number == '3') {
      this.spamTab = true;
    }
    else if (number == '4') {
      this.deleteTab = true;
    }
  }
}
